module.exports = __webpack_public_path__ + "img/book.af83e224.png";